import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=54c38a05&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=54c38a05&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c38a05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c38a05')) {
      api.createRecord('54c38a05', component.options)
    } else {
      api.reload('54c38a05', component.options)
    }
    module.hot.accept("./Admin.vue?vue&type=template&id=54c38a05&scoped=true", function () {
      api.rerender('54c38a05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin.vue"
export default component.exports